import { numberToPrettyString } from '@cian/utils';

import { getFlowMetersInfo } from './getFlowMetersInfo';
import { isDailyRent } from './isDailyRent';
import { IOfferCard } from '../../../types';

export function getUtilitiesTermsPrice(offerCard: IOfferCard): string | null {
  if (isDailyRent(offerCard.category)) {
    return null;
  }

  const { utilitiesTerms } = offerCard.bargainTerms;

  /**
   * Если с бекенда не приходит utilitiesTerms, значит ком. платежи включены,
   * так исторически сложилось
   */
  if (!utilitiesTerms) {
    return 'комм. платежи включены (без счётчиков)';
  }

  if (utilitiesTerms.includedInPrice) {
    return `комм. платежи включены ${getFlowMetersInfo(utilitiesTerms)}`;
  } else {
    if (utilitiesTerms.price === 0) {
      return 'комм. платежи не включены';
    } else {
      const priceRent = offerCard.bargainTerms.priceRur;
      const priceUtilities = utilitiesTerms.price;

      return `${numberToPrettyString(priceRent)} ₽ + ${numberToPrettyString(
        priceUtilities,
      )} ₽ комм. платежи ${getFlowMetersInfo(utilitiesTerms)}`;
    }
  }
}
